export const appName = "BRANO GROUP, a.s.";
